import React from "react";
import "../assets/scss/components/user-menu.scss";
import { Link } from "react-router-dom";
import { ReactComponent as ArrowDown } from "../assets/icons/arrow-down.svg";
import { useUserContext } from "../contexts/UserContext";
import { useTranslation } from "react-i18next";
import Dropdown from "./Dropdown";

const UserMenu = (props) => {
  const { t } = useTranslation();
  const { userData } = useUserContext();
  return (
    <div className={``}>
      <Dropdown
        dropdownTrigger={
          <div className="d-flex align-items-center user-dropdown">
            <svg
              width="20"
              height="20"
              viewBox="0 0 1.08 1.08"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path d="M.54.51A.21.21 0 1 0 .33.3a.21.21 0 0 0 .21.21m0-.36A.15.15 0 1 1 .39.3.15.15 0 0 1 .54.15" />
              <path d="M.914.731a.515.515 0 0 0-.748 0A.06.06 0 0 0 .15.772V.93a.06.06 0 0 0 .06.06h.66A.06.06 0 0 0 .93.93V.772A.06.06 0 0 0 .914.731M.87.93H.21V.772a.455.455 0 0 1 .66 0Z" />
              <path d="M0 0h1.08v1.08H0z" fill="none" />
            </svg>
            {!userData ? (
              <div>{t("Loading...")}</div>
            ) : (
              <>
                <p className="mb-0 hidden-sm">{userData.first_name}</p>
                <ArrowDown className="hidden-sm" />
              </>
            )}
          </div>
        }
        dropdownMenu={
          <>
            <div className="dropdown-item">
              <h5 className="mb-0">
                {userData.first_name} {userData.last_name}
              </h5>
              <p className="text-muted">
                <small>{userData?.email}</small>
              </p>
              <p className="mb-0">
                {/* role_name carries the actual (custom) role name; role stays
                    the enforcement value the SPA gates on. */}
                Role:{" "}
                <span className="text-uppercase">
                  {userData?.role_name || userData?.role}
                </span>
              </p>
              <p className="mb-0">
                Status:{" "}
                <span className="text-uppercase">
                  {userData?.latest_status}
                </span>
              </p>
            </div>
            <Link
              to="/user/logout"
              className="dropdown-item d-flex gap-2 align-items-center"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 1.08 1.08"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M.21.18h.48v.294h.06V.18A.06.06 0 0 0 .69.12H.21a.06.06 0 0 0-.06.06V.9a.06.06 0 0 0 .06.06h.48A.06.06 0 0 0 .75.9H.21Z" />
                <path d="M.845.518A.03.03 0 0 0 .803.56l.101.1H.469a.03.03 0 0 0-.03.03.03.03 0 0 0 .03.03h.435L.803.824a.03.03 0 1 0 .042.042L1.02.692Z" />
                <path d="M0 0h1.08v1.08H0z" fill="none" />
              </svg>
              {t("Log out")}
            </Link>
          </>
        }
      />
    </div>
  );
};

export default UserMenu;
